import { Link } from "react-router-dom";
import { MessageCircle, Lock } from "lucide-react";
import { NAV_ITEMS } from "./Header";
import { MSG, WHATSAPP_DISPLAY } from "../lib/site";
import { useCodes } from "../lib/CodesContext";
import { useLead } from "../lib/LeadContext";

const Footer = () => {
  const { setAdminOpen } = useCodes();
  const { openLead } = useLead();

  return (
    <footer className="relative border-t border-white/[0.06] bg-ink-950" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <img
              src="/assets/wordmark.webp"
              alt="NOVA ÉRA TV"
              loading="lazy"
              className="h-10 w-auto"
            />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Streaming com tecnologia P2P e 2 telas simultâneas. Ativação por
              código, instalação guiada e suporte direto no WhatsApp.
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Navegação
            </p>
            <nav className="mt-4 flex flex-col gap-2.5" data-testid="footer-nav">
              {NAV_ITEMS.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  data-testid={`footer-${item.testid}`}
                  className="text-sm text-slate-400 transition-colors hover:text-lime-350"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Atendimento
            </p>
            <button
              onClick={() => openLead(MSG.help)}
              data-testid="footer-whatsapp-link"
              className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 transition-colors hover:text-lime-350"
            >
              <MessageCircle className="h-4 w-4 text-lime-350" />
              WhatsApp {WHATSAPP_DISPLAY}
            </button>
            <p className="mt-3 text-xs leading-relaxed text-slate-500">
              Atendimento todos os dias. Contratação, renovação e suporte de
              instalação em um só lugar.
            </p>
          </div>
        </div>

        <div className="mt-12 rounded-2xl border border-white/[0.06] bg-ink-900/40 p-6" data-testid="popular-searches">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            Buscas populares
          </p>
          <nav className="mt-4 flex flex-wrap gap-2.5" aria-label="Buscas populares">
            {[
              { label: "novaera renovar", to: "/renovacao", testid: "kw-novaera-renovar" },
              { label: "nova era renovar", to: "/renovacao", testid: "kw-nova-era-renovar" },
              { label: "nova era código de renovação", to: "/renovacao", testid: "kw-codigo-renovacao" },
              { label: "novaera codigo", to: "/download", testid: "kw-novaera-codigo" },
              { label: "novaera iptv", to: "/informacoes", testid: "kw-novaera-iptv" },
              { label: "novaera p2p", to: "/informacoes", testid: "kw-novaera-p2p" },
              { label: "nova era tv 2 telas", to: "/", testid: "kw-nova-era-2-telas" },
              { label: "recarga nova era tv via pix", to: "/", testid: "kw-recarga-pix" },
            ].map((s) => (
              <Link
                key={s.testid}
                to={s.to}
                data-testid={s.testid}
                className="rounded-full border border-white/10 px-4 py-1.5 text-xs text-slate-400 transition-colors hover:border-lime-350/40 hover:text-lime-350"
              >
                {s.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-12 flex items-center justify-between border-t border-white/[0.06] pt-6">
          <p className="text-xs text-slate-600">
            © {new Date().getFullYear()} NOVA ÉRA TV — Todos os direitos reservados.
          </p>
          <button
            onClick={() => setAdminOpen(true)}
            data-testid="admin-trigger-button"
            aria-label="Área administrativa"
            className="rounded-full p-2 text-slate-800 opacity-40 transition-[opacity,color] duration-300 hover:text-lime-350 hover:opacity-100"
          >
            <Lock className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
